module.exports = __webpack_public_path__ + "img/robotmon_logo_1024x1024.53778c20.png";